<template>
  <div class="gs-section">
    <div class="gs-section__toolbar">
      <div class="gs-segmented" role="group" aria-label="Affiliate link type">
        <button
          v-for="group in linkGroups"
          :key="group.value"
          type="button"
          class="gs-segmented__item"
          :class="{ 'is-current': linkGroup === group.value }"
          :aria-pressed="linkGroup === group.value ? 'true' : 'false'"
          :data-group="group.value"
          @click="selectGroup(group.value)"
        >
          {{ group.title }}
        </button>
      </div>
      <p class="gs-section__count">{{ countLabel }}</p>
    </div>

    <div v-if="visibleLinks.length" class="gs-asset-grid">
      <asset-card
        v-for="(affiliateLink, index) in visibleLinks"
        :key="`${linkGroup}-${index}`"
        :title="affiliateLink.name"
      >
        <template slot="preview">
          <div class="gs-asset-mono">{{ affiliateLink.link }}</div>
        </template>
        <template slot="actions">
          <copy-button
            :text="affiliateLink.link"
            :label="copyLabel"
            :title="copyTitle"
          />
        </template>
      </asset-card>
    </div>

    <div v-else class="gs-empty">
      <span class="gs-empty__icon"><gs-icon name="link" size="22" /></span>
      <p class="gs-empty__title">{{ linkGroup === 'jv_broker_links' ? 'No affiliate recruitment links yet' : 'No custom landing page links yet' }}</p>
      <p class="gs-empty__text">
        Your affiliate links appear here as soon as the vendor publishes them.
      </p>
    </div>

    <p v-if="linkGroup === 'jv_broker_links' && visibleLinks.length" class="gs-section__note">
      <strong>{{ $t('frontend_resources_note') }}:</strong>
      {{ $t('frontend_resources_affiliate_recruitment_links_note') }}
    </p>
  </div>
</template>

<script>
import AssetCard from '@/components/promotools/AssetCard.vue';
import CopyButton from '@/components/promotools/CopyButton.vue';

export default {
  components: {
    AssetCard,
    CopyButton,
  },
  props: {
    initialGroup: { type: String, default: 'aff_links' },
    funnelResource: {
      type: Object,
      default: () => ({}),
    },
    directAffiliateLinks: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      linkGroup: this.initialGroup,
    };
  },
  computed: {
    jvBrokerLinks() {
      return (this.funnelResource
        && this.funnelResource.display_links
        && this.funnelResource.display_links.filter(link => link.type === 'second_tier')) || [];
    },
    hasJvBrokerLinks() {
      return this.jvBrokerLinks.length > 0;
    },
    linkGroups() {
      return [
        { title: 'Custom Landing Page Links', value: 'aff_links' },
        { title: 'Affiliate Recruitment Links', value: 'jv_broker_links' },
      ];
    },
    visibleLinks() {
      return this.linkGroup === 'jv_broker_links' ? this.jvBrokerLinks : (this.directAffiliateLinks || []);
    },
    countLabel() {
      const count = this.visibleLinks.length;
      return `${count} ${count === 1 ? 'link' : 'links'}`;
    },
    // The legacy widget labelled each read-only field with the kind of link
    // it held; the copy button is where that name lives now.
    copyLabel() {
      const noun = this.linkGroup === 'jv_broker_links'
        ? this.$t('frontend_resource_jv_broker_link')
        : this.$t('frontend_resource_affiliate_link');

      return `${this.$t('frontend_copy')} ${noun}`;
    },
    copyTitle() {
      return this.linkGroup === 'jv_broker_links'
        ? this.$t('frontend_resource_copy_jv_broker_link')
        : this.$t('frontend_resource_copy_affiliate_link');
    },
  },
  methods: {
    selectGroup(value) {
      this.linkGroup = value;
      this.$emit('group-change', value);
    },
  },
  watch: {
    initialGroup(value) { this.linkGroup = value; },
  },
};
</script>
